export const PENDING_SIGN_IN_GCS_ID_KEY = 'pending_sign_in_gcs_id';
